import React from "react";
import PropTypes from "prop-types";
import { VerticalTimelineElement } from "react-vertical-timeline-component";

import Icon from "components/Icon";
import Image from "components/Image";

import "./TimelineItem.scss";

const TimelineItem = ({ timeline, onShowDetail }) => {
  const { logo, stayBetween, companyName, positionName, jobDesc, smallDesc } = timeline;
  return (
    <VerticalTimelineElement
      className="vertical-timeline-element--work"
      onTimelineElementClick={() => onShowDetail(timeline)}
      // contentStyle={{ background: "rgb(122, 128, 133)", color: "#fff" }}
      contentArrowStyle={{ borderRight: "7px solid  rgb(33, 150, 243)" }}
      date={stayBetween}
      data-toggle="modal"
      //   iconStyle={{ color: "rgb(33, 150, 243)" }}
      icon={<Icon iconName="CodeIcon" size="3x" style={{ zIndex: 10000 }} className=" mb-3 " />}
    >
      <Image className="image-logo" fileName={logo} alt={companyName} />
      {/* <img
                  style={{ width: 70, height: 70, marginBottom: 10 }}
                  src="https://scontent.fbkk22-1.fna.fbcdn.net/v/t1.6435-9/45878479_10161252279455323_4524037980867788800_n.jpg?_nc_cat=1&ccb=1-5&_nc_sid=09cbfe&_nc_eui2=AeGHN3P2UljM-BdQf8w1Z8vnLhIcwnXvjKcuEhzCde-Mp9PcQ-WuAYeaUrzkRotImGUPYY4uwkjcR3tNyUP5WLJZ&_nc_ohc=1d9GBWWoz6kAX9TuHZ3&_nc_ht=scontent.fbkk22-1.fna&oh=00_AT8RK9SwX8vg9ncbBR484xMMZNGFZ7QNrr0py6oxNeeLsA&oe=626926ED"
                  alt="test"
                /> */}
      <h3 className="vertical-timeline-element-title">{positionName}</h3>
      <h6 className="vertical-timeline-element-subtitle">{companyName}</h6>
      {/* <div dangerouslySetInnerHTML={{ __html: jobDesc }} /> */}
      <ul className="mt-3">
        {smallDesc.map((x) => (
          <li key={x}>{x}</li>
        ))}
      </ul>
    </VerticalTimelineElement>
  );
};

TimelineItem.propTypes = {
  timeline: PropTypes.object.isRequired,
  onShowDetail: PropTypes.func.isRequired,
  //   className: PropTypes.string,
  //   frontmatter: PropTypes.object,
};

export default TimelineItem;
